import { useState } from 'react';
import { useI18n } from '../i18n';
import { download } from '../lib/download';

export function ExportButton({ year }: { year?: number }) {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  return (
    <>
      {err && <span className="err small">{err}</span>}
      <button className="btn" disabled={busy} onClick={async () => {
        setBusy(true); setErr(null);
        try { await download(`/api/export.xlsx${year ? `?year=${year}` : ''}`); } catch (e) { setErr((e as Error).message); } finally { setBusy(false); }
      }}>{busy ? t('common.exporting') : t('common.export')}</button>
    </>
  );
}
